import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/map-marker-alt.svg'
import _imports_1 from '@/assets/images/clock.svg'


const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "mid-container" }
const _hoisted_3 = { class: "career-details-page" }
const _hoisted_4 = { class: "career-details-banner" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "career-details-inner" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "career-details-sidebar" }
const _hoisted_9 = { class: "career-right-img" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "job-detail-rigth" }
const _hoisted_12 = { class: "job-short-des" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "career-details-content" }
const _hoisted_15 = { class: "job_des" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "job_des" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "job_des" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "job_des" }
const _hoisted_22 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_userHeader = _resolveComponent("userHeader")!
  const _component_jobForm = _resolveComponent("jobForm")!
  const _component_userFooter = _resolveComponent("userFooter")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_userHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.jobInfoData.jobTitle), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("img", {
                  src: _ctx.getCdnImageAddress(_ctx.jobInfoData.jobImage, `w_250,h_140/`)
                }, null, 8, _hoisted_10)
              ]),
              _createElementVNode("h4", null, _toDisplayString(_ctx.jobInfoData.jobTitle), 1),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _cache[0] || (_cache[0] = _createElementVNode("i", null, [
                      _createElementVNode("img", { src: _imports_0 })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.jobInfoData.location), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _cache[1] || (_cache[1] = _createElementVNode("i", null, [
                      _createElementVNode("img", { src: _imports_1 })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.jobInfoData.requiredExperience.from) + "+ years", 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", {
                  innerHTML: _ctx.jobInfoData.shortDescription
                }, null, 8, _hoisted_13)
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "apply-btn" }, [
                _createElementVNode("button", {
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#joinUs",
                  class: "primary-btn-outline"
                }, "Apply Now")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[3] || (_cache[3] = _createElementVNode("h3", null, "Job Description", -1)),
                _createElementVNode("p", {
                  innerHTML: _ctx.jobInfoData.jobDescription
                }, null, 8, _hoisted_16)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[4] || (_cache[4] = _createElementVNode("h3", null, "JOB REQUIREMENTS", -1)),
                _createElementVNode("p", {
                  innerHTML: _ctx.jobInfoData.jobRequirements
                }, null, 8, _hoisted_18)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[5] || (_cache[5] = _createElementVNode("h3", null, "KEY RESPONSIBILITIES ACTIVITIES", -1)),
                _createElementVNode("p", {
                  innerHTML: _ctx.jobInfoData.keyAndResponsibilities
                }, null, 8, _hoisted_20)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _cache[6] || (_cache[6] = _createElementVNode("h3", null, "BENEFITS", -1)),
                _createElementVNode("p", {
                  innerHTML: _ctx.jobInfoData.benefits
                }, null, 8, _hoisted_22)
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "apply-btn" }, [
                _createElementVNode("button", {
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#joinUs",
                  class: "primary-btn-outline"
                }, "Apply Now")
              ], -1))
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "clear" }, null, -1))
          ])
        ])
      ])
    ]),
    _createVNode(_component_jobForm),
    _createVNode(_component_userFooter)
  ]))
}